import React from "react";
import styled from "styled-components/macro";
import { Accessory } from "../types";
import { DefaultText, MainPrice, SecondaryPrice } from "theme/GlobalElements";
import { MdAddShoppingCart } from "react-icons/md";
import { showRootModal } from "features/rootModal/rootModalSlice";
import { useDispatch } from "react-redux";
import { PageWithFilterType } from "features/Filters/types";
import Labels from "components/Label/Labels";
import {
  ButtonsContainer,
  LabelsContainer,
  PriceAndButtons,
  CardLabels,
  InfoLabel,
  BottomSection,
  UpperSection,
  ProductContainer,
  ProductInfoContainer,
  LinkTo,
  PriceContainer,
} from "components/Product/ProductCard";
import { getLabels } from "components/Product/utils";
import DualPrice, { EuroPrice } from "components/Price";

interface AccessoryItemProps {
  item: Accessory;
}

const AccessoryItem: React.FC<AccessoryItemProps> = ({ item }) => {
  const dispatch = useDispatch();
  const hasPromotion = Number(item.price_promotion) > 0;

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    dispatch(
      showRootModal({
        modalType: "CHECKOUT",
        modalProps: { item, pageType: PageWithFilterType.accessories },
      })
    );
  };

  const labels = getLabels(item);

  return (
    <ProductContainer>
      <ProductInfoContainer>
        <LinkTo
          to={`/accessories/${encodeURIComponent(item.alias)}`}
          state={{ prevUrl: window.location.pathname }}
          aria-label={`Виж подробности за ${item.title}`}
        >
          <LabelsContainer>
            <Labels labels={labels} muted />
          </LabelsContainer>
          <UpperSection>
            <ProductImage>
              <Image
                alt={item.image.alt || item.title}
                src={`data:${item.image.contentType};base64,${item.image.image}`}
                loading="lazy"
                decoding="async"
              />
            </ProductImage>
            <Title>{item.title}</Title>
            <CardLabels>
              <InfoLabel>Аксесоар</InfoLabel>
            </CardLabels>
          </UpperSection>
        </LinkTo>

        <BottomSection>
          <PriceAndButtons>
            <PriceContainer>
              {hasPromotion && (
                <SecondaryPrice className="text-body">
                  <EuroPrice bgn={item.price} eur={item.price_eur} />
                </SecondaryPrice>
              )}
              <MainPrice className="text-md">
                <DualPrice
                  bgn={hasPromotion ? item.price_promotion : item.price}
                  eur={hasPromotion ? item.price_promotion_eur : item.price_eur}
                />
              </MainPrice>
            </PriceContainer>
            <AccessoryButtons>
              <AddButton
                className="card-button"
                type="button"
                onClick={onClick}
                aria-label={`Добави ${item.title} в количката`}
                title="Добави в количката"
              >
                <MdAddShoppingCart aria-hidden="true" />
              </AddButton>
            </AccessoryButtons>
          </PriceAndButtons>
        </BottomSection>
      </ProductInfoContainer>
    </ProductContainer>
  );
};

const ProductImage = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  aspect-ratio: 4 / 3;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 18px;
  background: #ffffff;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  aspect-ratio: 4/3;
`;

const Title = styled(DefaultText)`
  display: -webkit-box;
  min-height: 3em;
  margin: 16px 16px 0;
  overflow: hidden;
  font-size: 1rem;
  font-weight: 650;
  line-height: 1.5;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

const AccessoryButtons = styled(ButtonsContainer)`
  width: auto;
  flex: 0 0 auto;
`;

const AddButton = styled.button``;
export default AccessoryItem;
